import { render } from "./OrganizationFormPreschool.vue?vue&type=template&id=4c9e3b7d"
import script from "./OrganizationFormPreschool.vue?vue&type=script&lang=js"
export * from "./OrganizationFormPreschool.vue?vue&type=script&lang=js"

import "./OrganizationFormPreschool.vue?vue&type=style&index=0&id=4c9e3b7d&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__